import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { PlatformSectionService } from '../../platform-section/platform-section.service';
import { EditPlatformSection } from '../../platform-section/platform-section.interface';
import { PlatformFaqService } from '../platform-faq.service';
import {
  IFAQ,
  IFAQForm,
  IFAQUpdatePayload,
} from '../platform-faq.interface';

@Component({
  selector: 'app-edit-faq',
  templateUrl: './edit-faq.component.html',
  styleUrls: ['./edit-faq.component.scss']
})
export class EditFaqComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  sections$!: Observable<EditPlatformSection[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name, [Validators.required]),
    observations: new FormControl(this.data.observations, [Validators.required]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IFAQ,
    private dialogRef: MatDialogRef<EditFaqComponent>,
    private platformSectionService: PlatformSectionService,
    private platformFaqService: PlatformFaqService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    // this.getSectionsList();
  }

  getSectionsList() {
    let platformResponse = this.platformSectionService
      .getPlatformSections()

    platformResponse.subscribe({
      next: (sections: any) => {
        this.sections$ = of(sections.data as EditPlatformSection[]);
        this.isSectionsLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.platformFaqService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, observations } = this.form
      .value as IFAQForm;
    const updateFAQ: IFAQUpdatePayload = {
      id: this.data.id,
      name,
      observations
    };

    this.platformFaqService
      .updateFAQ(updateFAQ)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let errorMessage =
        environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(
        this.errorTitle,
        errorMessage,
        this.errorIcon
      );
    }
  }
}
